import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Column } from '../api/api';
import BoardColumn from './BoardColumn';
import './SortableColumn.css';

interface SortableColumnProps {
  column: Column;
  onAddTask: () => void;
  onDeleteColumn: () => void;
  onEditColumn?: () => void;
  onTaskUpdate: () => void;
  canDelete?: boolean;
}

const SortableColumn: React.FC<SortableColumnProps> = ({
  column,
  onAddTask,
  onDeleteColumn,
  onEditColumn,
  onTaskUpdate,
  canDelete = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `column-${column.id}`,
    data: {
      type: 'column',
      column,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="sortable-column-wrapper">
      <BoardColumn
        column={column}
        onAddTask={onAddTask}
        onDeleteColumn={onDeleteColumn}
        onEditColumn={onEditColumn}
        onTaskUpdate={onTaskUpdate}
        canDelete={canDelete}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  );
};

export default SortableColumn;
